import { Box, CircularProgress, Typography } from "@mui/material";
import { useAppCustomStyles } from "../assets/theme/custom/hooks";
import { useMaterialUIController } from "../context";
import { useClientBranding } from "../providers/ClientBrandingProvider";

type Props = {
  message: string;
};

/** Full-screen auth transition state (login / logout / callback). */
export default function AuthLoadingScreen({ message }: Props) {
  const custom = useAppCustomStyles();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { brandImageLight, brandImageDark, brandName } = useClientBranding();
  const logo = darkMode ? brandImageLight : brandImageDark;

  return (
    <Box className="spinner-overlay" sx={custom.components.authLoading.root}>
      <Box component="img" src={logo} alt={brandName} sx={custom.components.authLoading.logo} />
      <CircularProgress size={32} />
      <Typography variant="body1" color="text.primary">
        {message}
      </Typography>
    </Box>
  );
}
